<script setup lang="ts">
import { InfoProps } from "./Info.props"

defineProps<InfoProps>()
</script>

<template>
  <div class="info-wrapper gapped flex flex-col gap-6 md:grid md:grid-cols-12">
    <div
      v-if="images?.length"
      class="md:col-span-4"
      :class="
        images?.length > 1
          ? 'order-last grid grid-cols-2 gap-5 '
          : 'order-first'
      "
    >
      <UtilsWrapperImage
        v-for="image in images"
        :="image"
        :key="image.image.url"
        class="overflow-hidden rounded-lg"
        sizes="100vw sm:100vw lg:33vw"
      />
    </div>

    <div
      class="w-full space-y-4 md:space-y-6"
      :class="{
        'flex-1': images?.length,
        'col-span-8': images?.length,
        'pr-5': images?.length && images?.length > 1,
        'pl-5': images?.length && !(images?.length > 1),
        'col-span-12': !images?.length
      }"
    >
      <h1
        v-if="title && isBrandTitle"
        class="elephant-bold md:mammoth-bold uppercase"
      >
        {{ title }}
      </h1>

      <h2 v-else-if="title" class="elephant-bold md:mammoth-bold uppercase">
        {{ title }}
      </h2>

      <UtilsMarkdown
        v-if="description"
        :content="description"
        :inline="false"
        class="beaver md:pig markdown__brand-page"
        :useLinkStyle="useLinkStyleMarkdown"
      />
    </div>
  </div>
</template>
